import { render, staticRenderFns } from "./SystemBuildingAddressEdit.vue?vue&type=template&id=50af2086&scoped=true"
import script from "./SystemBuildingAddressEdit.vue?vue&type=script&lang=js"
export * from "./SystemBuildingAddressEdit.vue?vue&type=script&lang=js"
import style0 from "./SystemBuildingAddressEdit.vue?vue&type=style&index=0&id=50af2086&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50af2086",
  null
  
)

export default component.exports